import {
  ProjectsSortField,
  ProjectsSorting,
  ProjectsStatusFilter,
  ProjectsToolFilter,
} from '@contentlab/stores/projectsStore';
import {FeatureName, ProjectStatus} from '@contentlab/types/project';
import {SortId} from './ProjectsPageHeader';

export const convertSortingFieldToSortBy = (sorting: ProjectsSortField) => {
  switch (sorting) {
    case ProjectsSortField.UPDATED_AT:
      return 'updated_at';
    case ProjectsSortField.NAME:
      return 'name';
    case ProjectsSortField.CREATED_AT:
      return 'created_at';
    default:
      return 'updated_at';
  }
};

export const convertToolFilterToFeatureName = (
  toolFilter: ProjectsToolFilter
) => {
  switch (toolFilter) {
    case ProjectsToolFilter.ALL:
      return undefined;
    case ProjectsToolFilter.DUB:
      return FeatureName.AI_DUBBING;
    case ProjectsToolFilter.RESIZE:
      return FeatureName.REFORMATTING;
    case ProjectsToolFilter.REPHRASE:
      return FeatureName.REPHRASING;
    case ProjectsToolFilter.CAPTIONS:
      return FeatureName.CAPTIONS;
    case ProjectsToolFilter.UPSCALE:
      return FeatureName.UPSCALE;
    case ProjectsToolFilter.AI_AVATAR:
      return FeatureName.AI_AVATAR;
    default:
      return undefined;
  }
};

export const convertStatusFilterToProjectStatus = (
  statusFilter: ProjectsStatusFilter
) => {
  switch (statusFilter) {
    case ProjectsStatusFilter.ALL:
      return undefined;
    case ProjectsStatusFilter.READY_TO_USE:
      return ProjectStatus.READY;
    case ProjectsStatusFilter.IN_PROGRESS:
      return ProjectStatus.IN_PROGRESS;
    default:
      return undefined;
  }
};

export const convertSortingToSortId = (sorting: ProjectsSorting) => {
  switch (sorting.field) {
    case ProjectsSortField.UPDATED_AT:
      return SortId.RECENTLY_UPDATED;
    case ProjectsSortField.NAME:
      return SortId.NAME_A_TO_Z;
    case ProjectsSortField.CREATED_AT:
      return sorting.direction === 'asc' ? SortId.OLDEST : SortId.NEWEST;
    default:
      return SortId.RECENTLY_UPDATED;
  }
};

export const convertSortIdToSorting = (sortId: SortId): ProjectsSorting => {
  switch (sortId) {
    case SortId.RECENTLY_UPDATED:
      return {field: ProjectsSortField.UPDATED_AT, direction: 'desc'};
    case SortId.NAME_A_TO_Z:
      return {field: ProjectsSortField.NAME, direction: 'asc'};
    case SortId.OLDEST:
      return {field: ProjectsSortField.CREATED_AT, direction: 'asc'};
    case SortId.NEWEST:
      return {field: ProjectsSortField.CREATED_AT, direction: 'desc'};
    default:
      return {field: ProjectsSortField.UPDATED_AT, direction: 'desc'};
  }
};
